import * as types from '../constants/feeds';
import api from '../api';

export const fetchXMLFeedsStart = () => {
  return {
    type: types.FETCH_XML_FEEDS_START
  };
};

export const fetchXMLFeedsSuccess = (payload) => {
  return {
    type: types.FETCH_XML_FEEDS_SUCCESS,
    payload
  };
};

export const fetchXMLFeedsFailure = (err) => {
  return {
    type: types.FETCH_XML_FEEDS_FAILURE,
    err
  };
};

export const fetchXMLFeeds = (payload, cb) => (dispatch) => {
  dispatch(fetchXMLFeedsStart());

  api.get(`api.php?cmd=xmlFeeds`)
    .then(({ data }) => {
      const payload = data;
      dispatch(fetchXMLFeedsSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchXMLFeedsFailure(err));
    });
};

export const fetchPushFeedsStart = () => {
  return {
    type: types.FETCH_PUSH_FEEDS_START
  };
};

export const fetchPushFeedsSuccess = (payload) => {
  return {
    type: types.FETCH_PUSH_FEEDS_SUCCESS,
    payload
  };
};

export const fetchPushFeedsFailure = (err) => {
  return {
    type: types.FETCH_PUSH_FEEDS_FAILURE,
    err
  };
};

export const fetchPushFeeds = (payload, cb) => (dispatch) => {
  dispatch(fetchPushFeedsStart());

  api.get(`api.php?cmd=pushFeeds`)
    .then(({ data }) => {
      const payload = data;
      dispatch(fetchPushFeedsSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchPushFeedsFailure(err));
    });
};

export const setFeedDescStart = () => {
  return {
    type: types.SET_FEED_DESC_START
  };
};

export const setFeedDescSuccess = (payload) => {
  return {
    type: types.SET_FEED_DESC_SUCCESS,
    payload,
  };
};

export const setFeedDescFailure = (err) => {
  return {
    type: types.SET_FEED_DESC_FAILURE,
    err,
  };
};

export const setFeedDesc = (payload, cb) => (dispatch) => {
  dispatch(setFeedDescStart());

  api.post('api.php?cmd=setFeedDesc', payload)
    .then(({ data }) => {
      dispatch(setFeedDescSuccess(data));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(setFeedDescFailure(err));
    });
};

export const setFeedPausedStart = () => {
  return {
    type: types.SET_FEED_PAUSED_START
  };
};

export const setFeedPausedSuccess = (payload) => {
  return {
    type: types.SET_FEED_PAUSED_SUCCESS,
    payload,
  };
};

export const setFeedPausedFailure = (err) => {
  return {
    type: types.SET_FEED_PAUSED_FAILURE,
    err,
  };
};

export const setFeedPaused = (payload, cb) => (dispatch) => {
  dispatch(setFeedPausedStart());

  api.post('api.php?cmd=setFeedPaused', payload)
    .then(({ data }) => {
      dispatch(setFeedPausedSuccess(data));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(setFeedPausedFailure(err));
    });
};

export const fetchFeedInfoStart = () => {
  return {
    type: types.FETCH_FEED_INFO_START
  };
};

export const fetchFeedInfoSuccess = (payload) => {
  return {
    type: types.FETCH_FEED_INFO_SUCCESS,
    payload,
  };
};

export const fetchFeedInfoFailure = (err) => {
  return {
    type: types.FETCH_FEED_INFO_FAILURE,
    err,
  };
};

export const fetchFeedInfo = (payload, cb) => (dispatch) => {
  const { aff } = payload;

  dispatch(fetchFeedInfoStart());

  api.post(`api.php?cmd=feedInfo&aff=${aff}`, payload)
    .then(({ data }) => {
      const payload = data.data;
      dispatch(fetchFeedInfoSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchFeedInfoFailure(err));
    });
};


